/**
 * Japanese Privacy Policy translations
 */
export const privacy = {
  pageTitle: "プライバシーポリシー",
  heroSubtitle: "お客様のプライバシーは私たちにとって重要です。このポリシーでは、個人情報の収集、使用、保護方法について説明します。",
  lastUpdated: "最終更新日：2026年1月",
  effectiveDate: "発効日：2026年1月1日",

  intro: {
    title: "はじめに",
    welcome: "JCI開発評議会ユースフューチャーズオブザーバトリーへようこそ。私たちはお客様のプライバシーを保護し、データの取り扱いについて透明性を確保することに努めています。",
    commitment: "このプライバシーポリシーでは、収集する個人情報、その使用方法、およびお客様のデータに関する権利について説明します。私たちはデータ最小化と目的限定の原則に従っています。",
    scope: "このポリシーは、JCI（国際青年会議所）のメンバーおよび一般訪問者を含む、ユースフューチャーズオブザーバトリープラットフォームのすべてのユーザーに適用されます。",
  },

  controller: {
    title: "データ管理者",
    description: "お客様の個人情報を管理するデータ管理者は以下の通りです：",
    name: "JCI開発評議会",
    contact: "プライバシーに関するお問い合わせは以下までご連絡ください：",
  },

  collection: {
    title: "収集する情報",
    description: "プラットフォームとのやり取り方法に応じて、さまざまな種類の情報を収集します：",
    account: {
      title: "アカウント情報",
      email: "メールアドレス（認証および通知用）",
      name: "表示名（任意、パーソナライズ用）",
      avatar: "プロフィール画像（任意、安全に保存）",
      organization: "JCI組織所属（任意）",
    },
    preferences: {
      title: "ユーザー設定",
      language: "希望言語設定",
      theme: "ライト/ダークモード設定",
      country: "データ分析のフォーカス国",
      interest: "主な関心分野（例：メンタルヘルス、起業家精神）",
    },
    analytics: {
      title: "分析データ（同意時）",
      description: "分析に同意された場合、以下を収集します：",
      pages: "訪問ページとナビゲーションパターン",
      scroll: "コンテンツページでのスクロール深度",
      time: "プラットフォームでの滞在時間",
      device: "ブラウザとデバイスの種類（匿名化）",
    },
  },

  usage: {
    title: "データの使用方法",
    description: "お客様の情報は以下の目的で使用します：",
    purpose1: {
      title: "サービスの提供",
      description: "認証、体験のパーソナライズ、およびお客様が要求したオブザーバトリー機能の提供。",
    },
    purpose2: {
      title: "プラットフォームの改善",
      description: "ユーザーがプラットフォームとどのようにやり取りするかを理解し、機能を改善する（分析同意がある場合のみ）。",
    },
    purpose3: {
      title: "コミュニケーション",
      description: "通知をオプトインしている場合、プラットフォームに関する重要な更新を送信する。",
    },
    purpose4: {
      title: "セキュリティ",
      description: "不正アクセスから保護し、システムの整合性を維持する。",
    },
  },

  legal: {
    title: "処理の法的根拠",
    description: "GDPRに基づき、以下の法的根拠に基づいてデータを処理します：",
    consent: {
      title: "同意（第6条(1)(a)）",
      description: "分析トラッキングとマーケティングコミュニケーション用。いつでも同意を撤回できます。",
    },
    contract: {
      title: "契約の履行（第6条(1)(b)）",
      description: "アカウント作成時に要求されたサービスを提供するため。",
    },
    legitimate: {
      title: "正当な利益（第6条(1)(f)）",
      description: "セキュリティ対策と詐欺防止のため、お客様の権利とバランスを取って。",
    },
    obligation: {
      title: "法的義務（第6条(1)(c)）",
      description: "適用される法律および規制を遵守するため。",
    },
  },

  cookies: {
    title: "Cookieとローカルストレージ",
    description: "体験を向上させるためにCookieとブラウザストレージを使用します：",
    essential: {
      title: "必須Cookie",
      description: "認証と基本機能に必要。無効にできません。",
    },
    analytics: {
      title: "分析Cookie（Google Analytics 4）",
      description: "訪問者がサイトをどのように使用しているかを理解するのに役立ちます。同意がある場合のみ有効。",
    },
    preferences: {
      title: "設定ストレージ（localStorage）",
      description: "言語、テーマ、同意の選択をブラウザにローカルに保存します。",
    },
    manage: "Cookie設定はいつでも以下で管理できます",
    manageLink: "設定",
  },

  thirdParty: {
    title: "サードパーティサービス",
    description: "プラットフォームを運営するために以下のサードパーティサービスを使用しています：",
    ga4: "ウェブサイト分析と使用状況トラッキング（同意時）",
    lovable: "バックエンドインフラ、認証、データベース",
    osm: "JCIのグローバルプレゼンスを表示するインタラクティブマップ",
    fonts: "タイポグラフィ配信（Plus Jakarta Sansフォントファミリー）",
  },

  retention: {
    title: "データ保持",
    description: "記載された目的に必要な期間のみデータを保持します：",
    dataType: "データ種別",
    period: "保持期間",
    account: "アカウントデータ",
    accountPeriod: "アカウント削除または2年間の非アクティブまで",
    analytics: "分析データ",
    analyticsPeriod: "14ヶ月（Google Analyticsデフォルト）",
    logs: "エラーログ",
    logsPeriod: "90日",
  },

  rights: {
    title: "プライバシーの権利（GDPR）",
    description: "一般データ保護規則に基づき、以下の権利があります：",
    access: {
      title: "アクセス権",
      description: "保有するすべての個人データのコピーを要求する。",
    },
    rectification: {
      title: "訂正権",
      description: "不正確または不完全な個人データの訂正を要求する。",
    },
    erasure: {
      title: "消去権",
      description: "個人データの削除を要求する（「忘れられる権利」）。",
    },
    restriction: {
      title: "制限権",
      description: "特定の状況での処理の制限を要求する。",
    },
    portability: {
      title: "データポータビリティ権",
      description: "構造化された機械可読形式でデータを受け取る。",
    },
    object: {
      title: "異議申立権",
      description: "正当な利益に基づく処理またはダイレクトマーケティングに異議を唱える。",
    },
    exercise: "これらの権利を行使するには、以下を訪問してください",
    settingsLink: "設定ページ",
  },

  international: {
    title: "国際プライバシーコンプライアンス",
    description: "100カ国以上で活動するグローバル組織として、メンバーがいる場所の現地プライバシー法規制を尊重することに努めています。",
    commitment: "GDPRを基準（最も包括的な保護を提供するため）としていますが、以下を含む適用される現地プライバシー法にも準拠しています：",
    ukGdpr: "英国居住者向けのUK GDPR",
    lgpd: "ブラジル居住者向けのLGPD（一般データ保護法）",
    pipeda: "カナダ居住者向けのPIPEDA",
    appi: "日本居住者向けのAPPI（個人情報保護法）",
    localRights: "お住まいの国に特定のプライバシー法がある場合、追加の権利がある可能性があります。現地法の適用についてはお問い合わせください。",
  },

  children: {
    title: "子どものプライバシー",
    description: "ユースフューチャーズオブザーバトリーは、JCIの会員資格要件に沿って18歳以上のユーザー向けに設計されています。16歳未満の子どもからのデータを故意に収集することはありません。",
    action: "誤って未成年者のデータを収集したと思われる場合は、privacy@jci.ccまでただちにご連絡ください。",
  },

  security: {
    title: "データセキュリティ",
    description: "データを保護するために強力なセキュリティ対策を実施しています：",
    encryption: "すべてのデータは転送中（HTTPS/TLS）および保存時に暗号化",
    access: "厳格なアクセス制御により、情報を閲覧できる人を制限",
    rls: "行レベルセキュリティ（RLS）により、自分のデータのみにアクセス可能",
    audit: "定期的なセキュリティ監査と脆弱性評価",
  },

  transfers: {
    title: "国際データ移転",
    description: "お客様のデータは、米国および欧州連合を含む、居住国以外の国で処理される場合があります。",
    safeguards: "法律で要求される場合、標準契約条項（SCC）を含む適切な保護措置を確保しています。",
  },

  changes: {
    title: "このポリシーの変更",
    description: "慣行や法的要件の変更を反映するため、このプライバシーポリシーを定期的に更新する場合があります。",
    notification: "重要な変更は、メール（アカウントをお持ちの場合）またはプラットフォーム上の目立つ通知でお知らせします。上部の「最終更新日」は変更が行われた時期を示しています。",
  },

  contact: {
    title: "お問い合わせ",
    description: "このプライバシーポリシーについてご質問がある場合、または権利を行使したい場合は、ご連絡ください：",
    email: "プライバシーに関するお問い合わせ：",
    dpa: "権利が侵害されたと思われる場合は、お住まいの地域のデータ保護当局に苦情を申し立てる権利もあります。",
  },
} as const;
